import React from 'react'
import Card from '../shared/card/card.jsx'
import moment from 'moment'

import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'

export default React.createClass({
    render:function() {
        let taskType = getTaskTypeIconParser(this.props.card.taskType)
        let midIcon = '/common/latest/images/consumer/status-icons/reprice.png'
        let rightIcon = taskType.iconsrc
        let btnId = 'repriceCard' + this.props.numOfRepriceCards
        let fullDate = this.props.card.newTask.orderedDate
        let date = moment(fullDate).format('ddd') + '<br />' + moment(fullDate).format('M/DD')
        return (
            <Card
             headerTitle={this.props.card.header}
             headerLeftIcon={date}
             headerMidIcon={midIcon}
             headerRightIcon={rightIcon}
             moduleType={this.props.card.moduleType}
             btnText='See Details'
             btnStyle='btn btn-sm btn-info'
             btnId={btnId}
             btnOnClick={this.props.btnOnClick}
             noPullDown={this.props.noPullDown} >

             <p dangerouslySetInnerHTML={{ __html: this.props.card.content }} />
             <div className='row pull-down-xs-2'>
                 <div className='col-xs-6 text-center'>
                     <p style={{fontSize:'18px'}} className='brand-primary-color'><b>Old Price: ${this.props.card.cost}</b></p>
                 </div>
                 <div className='col-xs-6 text-center'>
                     <p style={{fontSize:'18px'}} className='brand-primary-color'><b>New Price: ${this.props.card.newCost}</b></p>
                 </div>

             </div>
            </Card>
        )
    }
})



// WEBPACK FOOTER //
// ./src/components/dashboard/reprice-card.jsx